<div [formGroup]="form" class="open-tile-toggle">
  <div [formGroupName]="question.key">
    <div *ngFor="let option of question.settings.choices" class="tile-container margin-bottom-small" [ngClass]="{ 'active': fieldValue[option.value] || (option.price && !option.is_optional) }">
      <div class="toggle-icon">
        <open-svg-icon name="{{ option.icon }}" class="small"></open-svg-icon>
      </div>
      <div class="toggle-content">
        <div class="included-badge" *ngIf="option.is_included && option.inclusion_tag">
          <span class="text-capsule bg-featured medium"><span class="strong-small text-white">{{ option.inclusion_tag }}</span></span>
        </div>
        <div class="toggle-label">
          <b class="label">{{ option.label }}</b>
          <div class="text-small" [innerHTML]="option.text"></div>
        </div>
        <div class="toggle-input">
          <open-price *ngIf="option.price && option.is_optional" [price]="option.price" [precision]="0" size="medium" class="margin-right-small font-700"></open-price>
          <span class="margin-right-small display-xsmall" *ngIf="option.price && option.is_included && !option.is_optional">Included</span>
          <mat-slide-toggle [formControlName]="option.value" [disabled]="isDisabled"></mat-slide-toggle>
        </div>
      </div>
      <div *ngIf="option.help && (!option.help.type || option.help.type === 'tooltip')" class="tooltip">
        <open-tooltip [tooltipContent]="option.help.content"></open-tooltip>
      </div>
    </div>
  </div>
</div>
